import React from 'react';
import './KeyLegend.css';

const KeyLegend = () => {
    return (
        <div className="keylegend">
            <h1>Hiya, I'm the Key!</h1>
        </div>
    )
}

export default KeyLegend;